module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1007-2f9f9b2332ef74af1224878cc29fdaf2.png";